import { useMutation, useQuery } from "react-query";
import DataService from '../../../config/DataServices'
import { useToast } from "../../../hooks/usetoast";
import { queryClient } from "../../../config"


const { getRequest, postRequest } = DataService()

export const useAddSubAdmin = () => {
    return useMutation({
        mutationFn: data => {
            return postRequest("/add-subadmin", { ...data })
        },
    })
}


export const useGetSubAdmin = ({ page, size, searchText, sortField, sortOrder, id, userId }) => {
    return useQuery({
        queryKey: ["sub-admin-login", page, size, searchText, sortField, sortOrder, id, userId],
        queryFn: () => {
            return getRequest(`/sub-admin-login?&page=${page}&size=${size}&search=${searchText}&sortField=${sortField}&sortOrder=${sortOrder}&id=${id}`)
        }
    })
}


export const useDeleteSub = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return getRequest(`/delete-subadmin/${data._id}`)
        },
        onSuccess: success => {
            if (!success?.status) {
                queryClient.refetchQueries("sub-admin-History");
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("sub-admin-History");
            return toast.success("Sub Admin Deleted By Admin Successfully")
        }
    })
}

export const useUpdateSubAdmin = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            if (data?.permission) {
                const selectedPermissions = data.permission.filter(permission => permission.title);
                sessionStorage.setItem('permission', JSON.stringify(selectedPermissions));
                data.permission = selectedPermissions; // Ensure it's passed correctly in the request
            }
            return postRequest("/update-subadmin", data);
        },
        
        onSuccess: (variables, data) => {
            queryClient.refetchQueries(["sub-admin-History", variables.userId]);

            return toast.success("Status updated");
        }
    });
};


export const useSubAdminHistory = ({ page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["sub-admin-History", page, size, searchText, sortField, sortOrder],
        queryFn: async () => {
            const permission = JSON.parse(sessionStorage.getItem('permission')) || null;

            const response = await getRequest(`/list-subadmins?page=${page}&size=${size}&search=${searchText}&sortField=${sortField}&sortOrder=${sortOrder}`);

            return { ...response, permission };
        }
    });
};
